export default "__VITE_ASSET__392999d4__"